import React from 'react';
import { Link } from 'react-router-dom';
import './VideoPlayer.css';

const VideoPlayer = () => {
  return (
    <div className="video-container">
      <div className="video-content">
        <video 
          className="video-desktop" 
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src="/assets/video-desktop.webm" type="video/webm" />
          <source src="/assets/video-desktop.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <video 
          className="video-mobile" 
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src="/assets/video-mobile.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <img 
          src="/assets/final_logo.svg" 
          alt="Logo" 
          className="logo"
        />
        <Link to="/privacy-policy" className="privacy-link">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default VideoPlayer;

